import axios from 'axios'
import { isAuthenticated, getToken, logout } from './Auth';

const ApiHandler = (baseURL: string, tokenPartNumber?: string) => {

    const api = axios.create({
        baseURL: baseURL + "/api/",
        responseType: `json`,
    });

    api.interceptors.request.use(function (config) {
        if (isAuthenticated() === true) {
            
            const token = getToken();
            if (token && config !== undefined && config.headers !== undefined) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            if (tokenPartNumber)
                config.headers.Authorization = `Bearer ${tokenPartNumber}`;

            return config;
        } else {
            return new Promise(() => {
                logout();
            });
        }
    }, function (error) {
        return Promise.reject(error);
    });

    api.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (error.message !== 'cancelled-by-request')
        {
            var buttonErrorPopup = document.getElementById("ErrorPopupButton");
            if (buttonErrorPopup) {
                var message = "";
                if (error.response) {
                    if (error.response.data?.message || error.response.data?.Message) {
                        message += error.response.data.message ? error.response.data.message : error.response.data.Message;
                    } else if (error.response.data?.errors) {
                        var errors = Object.keys(error.response.data.errors) as []
                        for (let index = 0; index < errors.length; index++) {
                            message += " " + error.response.data.errors[errors[index]][0].toString();
                        }
                    } else if (error.response.data?.data) {
                        message = error.response.data?.data;
                    } else if (error.response.data) {
                        message = error.response.data;
                    }
                }
                else {
                    message = error;
                }
                
                buttonErrorPopup.innerText = message;
                buttonErrorPopup.click();
            }
        }
        return Promise.reject(error);
    });

    return api;
};

export default ApiHandler;
